import { Component, EventEmitter, Output } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { getItaPaginatorIntl } from 'app/i18n/ita-paginator-intl';
import { GetDisplayFieldValuePipe } from 'app/pipes/get-display-field-value.pipe';
import { ListTableViewComponent } from '../table/table.component';

@Component({
	selector   : 'list-custom-view',
	templateUrl: './custom.component.html',
	styleUrls  : ['./custom.component.scss'],
	// i providers non si ereditano dal decoratore della classe base: vanno ridichiarati
	providers: [GetDisplayFieldValuePipe, {provide: MatPaginatorIntl, useFactory: getItaPaginatorIntl}]
})
export class ListCustomViewComponent extends ListTableViewComponent{

	@Output() reloadDatasetList = new EventEmitter<any>();

	trackById(index, element): any{
		return element.id;
	}

	reload(): void{
		this.reloadDatasetList.emit();
	}
}
